/** @jsx isolateComponent */

import { cloneElement, useContext } from 'react';

import { isolateComponent } from '@zapier/style-encapsulation';

import { UpgradeNudgeLayout } from '@zapier/upsells/src/components/UpgradeNudgeLayout';
import { UpgradeModalContext } from '@zapier/upsells/src/contexts';
import { Plan } from '@zapier/upsells/src/types';

import { NudgeImage } from '../NudgeImage';
import { getActiveView } from './getActiveView';

export type Props = {
  destinationPlan: Plan;
  onClose: () => void;
};

const CloseModalOnClick = ({ children, onClose }: any) =>
  cloneElement(children, {
    onClick: onClose,
  });

export const TaskLimitLowUpgradeNudge = ({
  destinationPlan,
  onClose,
}: Props) => {
  const {
    account,
    autoUpgradeToPlan,
    isAutoUpgradeEnabled,
    isLoading,
    tasksRemaining,
  } = useContext(UpgradeModalContext);

  const activeView =
    !isLoading && account?.plan && autoUpgradeToPlan
      ? getActiveView({
          autoUpgradeToPlan,
          currentPlan: account?.plan,
          destinationPlan,
          isAutoUpgradeEnabled,
          tasksRemaining,
        })
      : null;

  return (
    <UpgradeNudgeLayout
      bodyText={activeView?.bodyText}
      buttons={
        activeView
          ? activeView.buttons.map((button, key) => (
              /**
               * This only needs to exist until we can render the Payment app in web-ssr, as
               * that will allow us to upgrade users inside the modal (thereby eliminating the
               * need to close it) rather than taking them to the plan change page.
               */
              <CloseModalOnClick key={key} onClose={onClose}>
                {button}
              </CloseModalOnClick>
            ))
          : null
      }
      headingText="You're running low on tasks"
      id="tasks-low"
      image={<NudgeImage type="tasks-low" />}
      subtitleText="Heads Up"
    />
  );
};
